import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/layout.vue'
import layout2 from '@/layout/layout2.vue'

Vue.use(VueRouter)

const routes = [
   /* {
        path: '/result',
        component: layout2,
        redirect: '/result/pay_suc',
        name: 'pay_suc',
        children: [
            {
                path: 'pay_suc',
                name: 'pay_suc',
                component: () => import('@/views/pay_suc/index.vue'),
            },
        ]
    },*/
    {
        path: '/',
        name: 'layout',
        component: Layout,
        // redirect: '/redirect',
        // redirect: '/home',
        redirect: '/login',
        children: [
            {
                path: '/login',
                name: 'login',
                meta: {
                    title: '登录'
                },
                component: () => import('@/views/login-page/index.vue')
            },
            {
                path: '/register',
                name: 'register',
                component: () => import('@/views/register-page/index.vue')
            },
            {
                path: '/redirect',
                name: 'redirect',
                component: () => import('@/views/redirect-page/index.vue')
            },
            {
                path: 'home',
                name: 'home',
                component: () => import('@/views/home-page/index.vue')
            },
            {
                path: '/qrcode-pay',
                name: 'qrcode-pay',
                component: () => import('@/views/qrcode-pay/index.vue')
            },
            {
                path: '/result/pay_suc',
                name: 'pay_suc',
                component: () => import('@/views/pay_suc/index.vue')
            },
            {
                path: '/result/pay_suc_qrcode',
                name: 'pay_suc_qrcode',
                component: () => import('@/views/pay_suc_qrcode/index.vue')
            },
            {
                path: '/qrcode-pay-2',
                name: 'qrcode-pay-2',
                component: () => import('@/views/qrcode-pay-2/index.vue')
            },
            {
                path: '/to-pay-2',
                name: 'to-pay-2',
                component: () => import('@/views/to-pay-2/index.vue')
            },
            {
                path: '/result/pay_suc_qrcode_2',
                name: 'pay_suc_qrcode_2',
                component: () => import('@/views/pay_suc_qrcode_2/index.vue')
            },
            {
                path: 'unpaid-fee',
                name: 'unpaid-fee',
                component: () => import('@/views/unpaid-fee/index.vue')
            },
            {
                path: 'choose-fee',
                name: 'choose-fee',
                component: () => import('@/views/choose-fee/index.vue')
            },
            {
                path: 'choose-fee-detail',
                name: 'choose-fee-detail',
                component: () => import('@/views/choose-fee-detail/index.vue')
            },
            {
                path: 'pay-confirm',
                name: 'pay-confirm',
                component: () => import('@/views/pay-confirm/index.vue')
            },
            // {
            //     path: 'pay-ticket',
            //     name: 'pay-ticket',
            //     component: () => import('@/views/pay-ticket/ticketInfo.vue')
            // },
            {
                path: 'pay-confirm-second',
                name: 'pay-confirm-second',
                component: () => import('@/views/pay-confirm-second/index.vue')
            },
            {
                path: 'pay-record',
                name: 'pay-record',
                component: () => import('@/views/pay-record/index.vue')
            },
            {
                path: 'pay-record-detail',
                name: 'pay-record-detail',
                component: () => import('@/views/pay-record-detail/index.vue')
            },
            {
                path: 'pay-refund',
                name: 'pay-refund',
                component: () => import('@/views/pay-refund/index.vue')
            },
            {
                path: 'pay-situation',
                name: 'pay-situation',
                component: () => import('@/views/pay-situation/index.vue')
            },
            {
                path: 'pay-situation-detail',
                name: 'pay-situation-detail',
                component: () => import('@/views/pay-situation-detail/index.vue')
            },
            {
                path: 'pay-situation-download',
                name: 'pay-situation-download',
                component: () => import('@/views/pay-situation-download/index.vue')
            },
            {
                path: 'anonymous-pay',
                name: 'anonymous-pay',
                component: () => import('@/views/anonymous-pay/index.vue')
            },
            {
                path: 'anonymous-pay-detail',
                name: 'anonymous-pay-detail',
                component: () => import('@/views/anonymous-pay-detail/index.vue')
            },
            {
                path: 'add-account',
                name: 'add-account',
                component: () => import('@/views/add-account/index.vue')
            },
            {
                path: 'list-account',
                name: 'list-account',
                component: () => import('@/views/list-account/index.vue')
            },
            {
                path: 'ticket-title',
                name: 'ticket-title',
                component: () => import('@/views/ticket-title/index.vue')
            },
        ]
	},
	
    {
        path: '/404',
        name: 'error-404',
        meta: {
            title: '404-页面不存在'
        },
        hidden: true,
        component: () =>
            import ('@/pages/error/404')
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true,
		meta: {}
	}
]

const router = new VueRouter({
    routes
})

export default router
